export function currencySymbol(currency) {
    if (!currency) return '';
    if (typeof currency === 'object') {
        const raw = currency.symbol || currency.code || currency.name || '';
        return currencySymbol(raw);
    }
    const normalized = String(currency).trim().toUpperCase();
    if (['PEN', 'SOLES', 'SOL', 'S/.'].includes(normalized)) return 'S/';
    if (['USD', 'DÓLARES', 'DOLARES', 'DOLLARS', '$'].includes(normalized)) return '$';
    if (['EUR', 'EUROS', '€'].includes(normalized)) return '€';
    return String(currency).trim();
}

export function formatCurrencyAmount(currency, amount) {
    if (amount == null || amount === '') return '-';
    const symbol = currencySymbol(currency);
    const numericAmount = Number(amount);
    const formattedAmount = Number.isFinite(numericAmount) ? numericAmount.toFixed(2) : amount;
    return `${symbol} ${formattedAmount}`.trim();
}

export function purchaseOrderInvoiceAmountLeft(row) {
    const billedAmount = (row?.bills ?? []).reduce(
        (acc, bill) => acc + Number(bill?.total || 0),
        0
    );
    return (Number(row?.total || 0) - billedAmount).toFixed(2);
}
